import BigNumber from 'bignumber.js';
import { useMemo } from 'react';
import { useQuery } from '@ywwwtseng/react-kit';
import * as web3 from '@ywwwtseng/web3';
import * as schema from '@/db/schema';
import type { UnifiedToken } from '@/types';

import { useTokenPrice } from './useTokenPrice';

export function useUnifiedUserBalance(token?: UnifiedToken) {
  const { data: balances } = useQuery<
    (typeof schema.user_balances.$inferSelect)[]
  >('user_balances', {
    refetchOnMount: true,
  });

  const { value: tokenPrice } = useTokenPrice(token?.id);

  const formatted = useMemo(() => {
    if (!token) {
      return '0';
    }

    return token.unified
      .map((t) => {
        return web3.utils.formatUnits(
          balances?.find((balance) => balance.token_id === t.id)?.amount ?? '0',
          t.decimals
        );
      })
      .reduce((acc, value) => {
        return acc.plus(new BigNumber(value));
      }, new BigNumber(0))
      .toFixed();
  }, [balances, token]);

  const price = useMemo(() => {
    if (!tokenPrice || !formatted) {
      return undefined;
    }
    return new BigNumber(formatted)
      .multipliedBy(new BigNumber(tokenPrice))
      .toFixed();
  }, [formatted, tokenPrice]);

  return {
    // value,
    formatted,
    price,
  };
}
